import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../app/guards'

export const Route = createFileRoute('/_app/pos/shifts')({
  staticData: { crumb: 'posShifts' },
  // Supervisors see every shift; managers who close other cashiers' shifts read those too.
  beforeLoad: ({ context }) => requireAnyPermission(context.session, 'pos.view_shift', 'pos.manage_shifts'),
  component: Outlet,
})
